import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { Record } from '@idto';
import { SearchRepositoryService } from '@service/search-repository/search-repository.service';
import { Subscription } from 'rxjs';
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';
import { UrlTranslateService } from '@service/helpers/url-translate.service';

interface ProductInterface
{
  sliderLink: string,
}

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductComponent implements OnInit
{
  @Input() section: ProductInterface;
  @Input() margin: BlockMargin;
  product: Record;
  productSubscription: Subscription;

  constructor(
    public changeDet: ChangeDetectorRef,
    public searchService: SearchRepositoryService,
    public marginService: MarginService,
    public urlTranslateService: UrlTranslateService
  ) { }

  ngOnInit(): void
  {
    this.productSubscription = this.searchService.fetchByQuery(this.section.sliderLink + '&c=1').subscribe(res =>
    {
      this.product = res.searchResult?.records?.length ? res.searchResult?.records[0] : null;
      this.changeDet.detectChanges();
    });
  }

  ngOnDestroy(): void
  {
    this.productSubscription.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();
  }
}
